import Spotlight from './Spotlight'

export default Spotlight
// eslint-disable-next-line import/export
export * from './Spotlight'
